<template>
    <div>
        <Wp_nav_bar title="我的总预估收入详情(淘宝)" :has-click="true" @click="clickToBack"></Wp_nav_bar>
        <Wp_tb_order_count_detail_model></Wp_tb_order_count_detail_model>
    </div>
</template>

<script>
    import Wp_tb_order_count_detail_model from "./Wp_tb_order_count_detail_model";
    import Wp_nav_bar from "../../custom/Wp_nav_bar";
    export default {
        name: "Wp_order_count_detail_page",
        components: {Wp_nav_bar, Wp_tb_order_count_detail_model},

        methods:{
            clickToBack(){
                this.$common_tb.back_from_count_new = true;
                this.$router.back();
            }
        }
    }
</script>

<style scoped>

</style>